<div>
  <div class="attention">
    <h1>Whoops!</h1>
    <h4>Das hat wohl nicht geklappt...</h4>
  </div>
  <h2 class="h3" *ngIf="is404" class="resultQuery">
    Der Server konnte die angefragte Ressource nicht finden :(
  </h2>
  <h2 class="h3" *ngIf="!is404" class="resultQuery">
    Es gab einen Fehler bei der Bearbeitung ihrer Anfrage.
  </h2>
  <div class="pt-5" style="display: flex; justify-content: center">
    <a color="primary" [routerLink]="['/']" [replaceUrl]="true">
      Zurück zur Startseite
    </a>
  </div>
</div>
